import { Card, CardBody, CardHeader } from 'react-bootstrap';
import { BsArrowRight, BsCheckCircleFill, BsXCircleFill } from 'react-icons/bs';

const policies = [
  'Check-in: 1:00 pm - 9:00 pm', 
  'Check out: 11:00 am', 
  'Self-check-in with building staff', 
  'No pets', 
  'No parties or events', 
  'Smoking is allowed'
];

const HotelPolicies = ({ policiesHtml, generalTermsHtml }) => {
  const htmlContent = policiesHtml || generalTermsHtml || '';
  const hasHtml = typeof htmlContent === 'string' && htmlContent.trim() !== '';
  return (
    <Card className="bg-transparent">
      <CardHeader className="border-bottom bg-transparent px-0 pt-0">
        <h3 className="mb-0">Hotel Policies</h3>
      </CardHeader>
      <CardBody className="pt-4 p-0">
        {hasHtml ? (
          <div className="mb-3" dangerouslySetInnerHTML={{ __html: htmlContent }} />
        ) : (
          <>
            <ul className="list-group list-group-borderless mb-2">
              <li className="list-group-item d-flex align-items-start">
                <BsCheckCircleFill className="me-2" />
                This is a family-friendly hotel, hence we request you to maintain a peaceful environment.
              </li>
              <li className="list-group-item d-flex align-items-start">
                <BsCheckCircleFill size={24} className="me-2" />
                Drinking and smoking within controlled limits are permitted at the hotel but please do not create a mess or disturbance.
              </li>
              <li className="list-group-item d-flex align-items-start">
                <BsCheckCircleFill size={18} className="me-2" />
                Drugs and intoxicating illegal products are banned and not to be brought to the hotel or consumed.
              </li>
              <li className="list-group-item d-flex align-items-start">
                <BsXCircleFill className="me-2" />
                For any update, the customer shall pay applicable cancellation/modification charges.
              </li>
            </ul>
            <ul className="list-group list-group-borderless mb-2">
              {policies.map((item, idx) => (
                <li key={idx} className="list-group-item h6 fw-light mb-0 items-center">
                  <BsArrowRight className="me-2" />
                  {item}
                </li>
              ))}
            </ul>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default HotelPolicies;

